export default __webpack_public_path__ + "static/media/delivery-box-add-operation-02.2ce57898.png";